import { render, staticRenderFns } from "./RelateInvoicesDialog.vue?vue&type=template&id=1dd0304a"
import script from "./RelateInvoicesDialog.vue?vue&type=script&lang=js"
export * from "./RelateInvoicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports